import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/membership/membershipBanner.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/membership/membershipCourseBanner.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/membership/membershipFaq.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/membership/membershipFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/membership/membershipOverview.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/membership/primeMembership.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/why-medh/Certified.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/shared/wrappers/PageWrapper.tsx");
